var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alipdf"},[_c('div',{staticClass:"main"},[_c('iframe',{attrs:{"allowfullscreen":"","id":"aliyunPreview","frameborder":"0","scrolling":"no","src":"http://preview.imm.aliyun.com/index.html"}})])])
}]

export { render, staticRenderFns }